// components/Skeleton.tsx
"use client";

import clsx from "clsx";
import {type SkeletonProps} from "@/types/types";


export const Skeleton = ({
  type = "block",
  lines = 3,
  className,
  shimmer = false,
}: SkeletonProps) => {
  const baseClass = clsx(
    "bg-gray-300 rounded-md relative overflow-hidden",
    shimmer
      ? "before:animate-shimmer before:absolute before:inset-0 before:-translate-x-full before:bg-gradient-to-r before:from-transparent before:via-white/40 before:to-transparent"
      : "animate-pulse",
    className,
  );

  if (type === "text") {
    return (
      <div className={clsx("space-y-2", className)}>
        {Array.from({length: lines}).map((_, i) => (
          <div key={i} className={clsx("h-4 w-full", baseClass)} />
        ))}
      </div>
    );
  }

  if (type === "avatar") {
    return <div className={clsx("w-16 h-16 rounded-full", baseClass)} />;
  }

  if (type === "card") {
    return (
      <div className="p-4 border rounded-lg space-y-4">
        <Skeleton type="block" className="h-40 w-full" shimmer={shimmer} />
        <Skeleton type="text" lines={2} shimmer={shimmer} />
      </div>
    );
  }

  // Default block skeleton
  return <div className={clsx("min-h-[100px] w-full", baseClass)} />;
};
